/**
 * Utils Factory
 */
//jshint ignore:start
(function () {

    'use strict';

    angular.module('itxApp.common')
        .service('ItxUtilsFct', ItxUtilsFct);

    ItxUtilsFct.$inject = [
        'ItxScreenSizeSvc', 
        'ItxConstants', 
        '$timeout',
        'ItxCategoryLayoutSvc',
        '$q',
        'CmsConfigSvc'
    ];

    /**
     * Utilities shared in the app
     * @constructor
     */
    function ItxUtilsFct(
        ItxScreenSizeSvc, 
        ItxConstants, 
        $timeout,
        ItxCategoryLayoutSvc,
        $q,
        CmsConfigSvc
    ) {

        var firstTime = true;
        var arabe = inditex.iLangId == '-44';
        var hebreo = inditex.iLangId == '-52';

        return {
            /**
             * Function to get non-excluded categories from Inditex JSON (excluded EXCLUSIONs, MOBILE, APP and DIVIDERs categories)
             * @param {Array} categories - Categories from the Inditex Store JSON
             * @return {Array} Filtered categories
             * Every .name property of an object is checked before using it because of an incompatibility with IE8
             */
            getFilteredCategories: function (categories) {
                var filteredCategories = [];

                for (var index in categories) {
                    var category = categories[index];

                    if (category &&
                        typeof category !== 'function' &&
                        ((category.name && category.name.length > 0 && !category.name.match(/DIVIDER/) ||
                            (category.key && !category.key.match(/_(EMPTY|NEWCOLUMN)$/)))
                        )) {

                        var exclusions = [];
                        _.each(category.attachments, function (attachment) {
                            if (attachment.type === 'EXCLUSION') {
                                exclusions.push(attachment.name);
                            }
                        });

                        if (category.key.indexOf('_MOBILE') === -1 &&
                            category.key.indexOf('_APP') === -1 &&
                            exclusions.indexOf(inditex.iStoreJSON.countryCode) === -1) {
                            filteredCategories.push(category);
                        }
                    }
                }

                return filteredCategories;
            },

            /**
             * Check if element is in viewport
             * @returns {boolean}
             */
            isElementInViewport: function (element) {
                //special bonus for those using jQuery
                if (typeof jQuery === 'function' && element instanceof jQuery) {
                    element = element[0];
                }

                var rect = element.getBoundingClientRect();

                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            },

            /**
             * Identify a children category
             * @param {Category} category
             * @returns {boolean}
             */
            isChildrenCategory: function (category) {
                if (category && category.hasOwnProperty('parentCategory')) {
                    if (category.parentCategory.key === 'ALL_BYG' || category.parentCategory.key === 'BYG') {
                        return true;
                    } else {
                        return this.isChildrenCategory(category.parentCategory);
                    }
                }
                return false;
            },

            /**
             * Get image type
             * @param {string} type - reference to ItxConstants
             * @returns {integer}
             */
            getImageType: function (type) {
                return ItxConstants.imageTypes[type];
            },

            /**
             * Get image size
             * @param {string} size - reference to ItxConstants
             * @returns {integer}
             */
            getImageSize: function (size, isDouble) {
                if (!isDouble) {
                    return ItxConstants.imageSizes[size][deviceSize()];
                } else {
                    //only grid
                    return ItxConstants.imageSizes.doubleGrid[extendedDeviceSize()];
                }
            },
            /**
             * Get image xmedia size
             * @param {integer} size - reference to ItxConstants
             * @returns {array}
             */
            getImageXmediaSize: function (size) {
                return ItxConstants.xmediaSizes[size];
            },
            scrollTo: function (selector) {
                $('html, body').animate({
                    scrollTop: $(selector).offset().top
                }, 250);
            },
            scrollToPoupSizes: function (selector) {
                if(ItxScreenSizeSvc.is('xs,sm')){
                    $('.ngdialog').animate({
                        scrollTop: $('#product-images-grid').outerHeight(true)
                    }, 250);
                } else {
                    $('.ma-product-dialog .ma-product-detail-wrap').animate({
                        scrollTop: 0
                    }, 250);
                }
                
            },
            /**
             * Show overlay background and add given class to the body in order to show only the important thing
             * @param {string} className - Class name of the element to show
             */
            overlayIn: function (hasDialog){
                var parent = hasDialog ? '.ngdialog ' : '.product-page ';
                var isIpad = /ipad/.test(window.navigator.userAgent.toLowerCase()); 
              
                $(parent).addClass('ma-has-nosize');
                if (!isIpad) {
                    $(parent + '.overlay-bg').show();
                }
            

                if (hasDialog){
                    this.scrollToPoupSizes();
                } else {
                    var posTitleProduct = $('.ma-product-detail-wrap').offset().top - 70;
                    var scrollOffset = (ItxScreenSizeSvc.is('xs,sm'))? posTitleProduct : 0;
                    $('html, body').animate({
                        scrollTop: scrollOffset
                    }, 250);
                }
            },
             /**
             * hide overlay background and remove given class from the body
             * @param {string} className - Class name to remove from the body.
             */
            overlayOff: function(hasDialog){
                var parent = hasDialog ? '.ngdialog ' : '.product-page ';
                $(parent).removeClass('ma-has-nosize');
                
                $timeout(function(){
                    $(parent + '.overlay-bg').hide();
                }, 250);  
            },

            getAkamaiImage: function(img, width){
                
                var sizes = [50, 100, 250, 400, 600, 800, 1000, 1200, 1400, 1600, 1980, 2200];
                var i = sizes.length-1
                var selectedSize = sizes[i];
                while (sizes[i]> width && i >=0){
                    selectedSize = sizes[i];
                    i--;
                }
                
                 url = _.map(url, function(url ){
                        url = url.replace('_5.', '_16.'); //Reemplazamos para ir a buscar la master
                        url = url.replace('_5.', '_16.'); //Reemplazamos para ir a buscar la master
                        url = url.replace(/\?t=.*/, '?width='+_this.getImageXmediaSize(idImageSize).width+'policy=high&ts='+inditex.iCustomTs);
                        
                        return url;
                    })                   
                    
                    if(url.length>0){
                        return url;
                    }   
              
            },
            /**
             * Get product images urls. 
             * @return {array} product images
             * @param {object} catentry - JSON object with xmedia info
             * @param {number} colorCode - color code
             * @param {string} localization - xmedia localization.
             * @param {string} imageType - image type
             * @param {string} imageSize - image size
             * @param {string} imageSize - double
             */
            getProductXmediaImagesData: function(product ,location, width ){
                // el objecto selectedColor no siempre existe
                var id = null;
                // xmediaset para la primera inicializacion de producto
                var set = null;

                if(product.state.selectedColor && product.state.selectedColor.id){
                    id = product.state.selectedColor.id;
                    
                    // Si es el color del set que viene en el estilismo buscamos las imagenes del
                    if(product.state.idSetColor == id){
                        set = product.activeDetail.xmediaDefaultSet;
                    };
                }
                /*
                if(firstTime){
                    for(var x = 0; x< 10; x++){

                        inditex.iStoreJSON.details.xmedia.xmediaSizes[0].sizeItems.push({sizes:[ {width: 1900, idSize: 16, code: "16", height: 2532}], format: 6, clazz: 8});
                        inditex.iStoreJSON.details.xmedia.xmediaSizes[0].sizeItems.push({sizes:[ {width: 1900, idSize: 16, code: "16", height: 2532}], format: 6, clazz: 13});
                        inditex.iStoreJSON.details.xmedia.xmediaSizes[0].sizeItems.push({sizes:[ {width: 1900, idSize: 16, code: "16", height: 2532}], format: 6, clazz: 14});
                    }
                    firstTime = false;
                }
                */
                var arr = inditex.getProductXmediaImagesData (product.activeDetail,
                                                id,
                                                location,
                                                set || inditex.iStoreJSON.details.xmedia.defaultStoreSet,
                                                width,
                                                width);                                  
                return arr; 

            },
            getImageProductUrls: function (catentry, colorCode, localization, imageType, imageSize, isDouble) {
                
                var _this = this;
                var idImageSize = this.getImageSize(imageSize, isDouble);  
                //AKAMAI image manager
             
                if (this.isXmediaEnabled(catentry)) {

                    var idImageSize = this.getImageSize(imageSize, isDouble);
                    
                    // Si se solicita recorte de color no lo buscamos del SET
                    var xmediaSet = catentry.xmediaDefaultSet;
                    if(localization == 'colorcut'){
                        xmediaSet = null;
                    }

                    var arrayImg = inditex.getProductXmediaUrls(catentry,
                                                colorCode,
                                                ItxConstants.xmediaLocations[localization],
                                                xmediaSet || inditex.iStoreJSON.details.xmedia.defaultStoreSet,
                                                this.getImageXmediaSize(idImageSize).width,
                                                this.getImageXmediaSize(idImageSize).height);          

                    // catentry.defaultImageType !== null 
                    // inditex.iPage === "ItxCategoryPage"
                    // Se ha eliminado esta validación porque siempre viene a null y los recortes de color muestran imagenes de producto (que hace?)
                    if( localization == 'colorcut' && arrayImg.length >= 1){
                        // Los estilismos solo devuelven un recorte de color
                        if(arrayImg.length === 1){
                            return [arrayImg[0]];
                        } else {
                            return [arrayImg[1]];
                        } 

                    } else {

                        return arrayImg;
                    }

                } else {
                    var image = catentry.image;
                    if (catentry.colors && catentry.colors.length > 0) {
                        var color = _.find(catentry.colors, function (color) {
                            return color.id == colorCode;
                        });
                        image = color? color.image :image;
                        if(!image){
                            image = catentry.colors[0].image;
                        }
                    }
                    return inditex.getProductImageUrls(
                            image,
                            this.getImageType(imageType),
                            this.getImageSize(imageSize));    
                }
                
            },
            
            getImageProductNames : function(catentryJSON, colorCode, localization) {
                
                var self = this;
                var loc = ItxConstants.xmediaLocations[localization];
                var set = catentryJSON.xmediaDefaultSet || inditex.iStoreJSON.details.xmedia.defaultStoreSet;
                //Obtenemos la informacion de xmedia de los jsons de producto y tienda.
                var xmedia = catentryJSON.xmedia;
                var xmediaSets;
                var xmediaFormats;
                if (inditex.iStoreJSON.details.xmedia) {
                    xmediaSets = inditex.iStoreJSON.details.xmedia.xmediaSets;
                    xmediaFormats = inditex.iStoreJSON.details.xmedia.xmediaFormats;

                }

                if (xmedia && xmediaSets && xmediaFormats 
                        && xmedia.length > 0 && xmediaSets.length > 0 && xmediaFormats.length > 0) {
                    var xmediaLocations = [];
                    var xmediaItems = [];
                    var imageNames = [];

                    //Obtenemos la base uri y el folder a partir del set recibido.
                    var base = '';
                    var folder = '';
                    for (var i = 0; i < xmediaSets.length; i++) {
                        if (xmediaSets[i].set === set) {
                            base = xmediaSets[i].baseUri;
                            if (xmediaSets[i].folder) {
                                folder = xmediaSets[i].folder;
                            }
                            break;
                        }
                    }

                    //Obtenemos el path a partir del colorCode recibido. Si no le pasamos ninguno, coge el primero
                    if (!colorCode && xmedia.length > 0) {
                        colorCode = xmedia[0].colorCode;
                    }
                    var path = '';
                    for (var i = 0; i < xmedia.length; i++) {
                        if (xmedia[i].colorCode === colorCode) {
                            path = xmedia[i].path;
                            xmediaLocations = xmedia[i].xmediaLocations;
                            xmediaItems = xmedia[i].xmediaItems;
                            break;
                        }
                    }

                    //Montamos el path con todo lo obtenido hasta ahora: base uri + path + folder.
                    if (base.charAt(base.length-1) === path.charAt(0) && base.charAt(base.length-1) === '/') {
                        base = base.substring(0,base.length-1);
                    }
                    if (folder.length > 0 && path.charAt(path.length-1) === folder.charAt(0) && path.charAt(path.length-1) === '/') {
                        path = path.substring(0,path.length-1);
                    }
                    var fullPath = base + path + folder;

                    //A partir del set recibido, obtendremos el formato y el timestamp de las imagenes y lo guardaremos en un map,
                    //cuya key es el nombre de la imagen.
                    var imagesData = new Map();
                    for (var i = 0; i < xmediaItems.length; i++) {
                        if (xmediaItems[i].set === set) {
                            for (var j = 0; j < xmediaItems[i].medias.length; j++) {
                                imagesData.set(xmediaItems[i].medias[j].idMedia, xmediaItems[i].medias[j]);
                            }
                            break;
                        }
                    }

                    //Si estamos en una CategoryPage, la primera imagen es la indicada en el campo defaultImageType del json de producto
                    var defaultImage = '';
                    if (inditex.iPage === "ItxCategoryPage" && inditex.iCategoryId) {
                        if (catentryJSON.defaultImageType) {
                            defaultImage = catentryJSON.defaultImageType;
                            imageNames.push(defaultImage);
                        }
                    }
                    //A partir del set y la loc recibidas, obtenemos el nombre de las imagenes para las que es necesario obtener las urls.
                    for (var i = 0; i < xmediaLocations.length; i++) {
                        if (xmediaLocations[i].set === set) {
                            for (var j = 0; j < xmediaLocations[i].locations.length; j++) {
                                if (xmediaLocations[i].locations[j].location === loc) {
                                    for (var k = 0; k < xmediaLocations[i].locations[j].mediaLocations.length; k++) {
                                        if (defaultImage !== xmediaLocations[i].locations[j].mediaLocations[k]) {
                                            imageNames.push(xmediaLocations[i].locations[j].mediaLocations[k]);
                                        }
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }
                    return imageNames;
                }
            },
            /**
             * use xmedia for current catentry
             * @return {boolean} 
             * @param {object} catentry - JSON object with xmedia info
             */
            isXmediaEnabled: function(catentry) {
                return (inditex.iStoreJSON.details.xmedia !== null) && (catentry.xmedia !== null);
            },
            /**
             * Try to hide the software keyboard
             */
            hideKeyboard: function (element) {
                setTimeout(function () {
                    $(element).blur();
                }, 100);
            },
            /**
             * Publish Event using javascript
             */
            publish: function (eventName, eventData) {
                var event;

                if (window.CustomEvent && !isInternetExplorer()) {
                    event = new CustomEvent(eventName, {
                        bubbles: true,
                        cancelable: true,
                        detail: eventData
                    });
                } else if (document.createEvent) {
                    event = document.createEvent('CustomEvent');
                    event.initCustomEvent(eventName, true, true, eventData);
                }
                document.dispatchEvent(event);
            },

            scrollTopProduct: function () {
                var heightButtons = 52;
                var nameSessionNav = 'ma-product-nav-hide';
                if(ItxScreenSizeSvc.is('xs')){
                    if(window.sessionStorage.getItem(nameSessionNav)){
                        $(window).scrollTop(heightButtons);
                        // $('html,body').animate({ scrollTop: heightButtons }, 0);
                    } else {
                        $('html,body').animate({ scrollTop: heightButtons }, 0);
                        window.sessionStorage.setItem(nameSessionNav, true);
                    }
                } else {
                    $(window).scrollTop(0);
                    // $('html,body').animate({ scrollTop: 0 }, 0);
                }
            },

            isRtlLanguage: function(){
                if(arabe || hebreo){
                    return true;
                }
            },

            getTimeZone: function(){
                let tz = undefined;
    
                if(inditex && inditex.iStoreJSON){
                    let country = inditex.iStoreJSON.countryCode;
                    if(country){
                        tz = ItxConstants.timezonesByCountryCode[country];
                    }
                }
    
                return tz;
            },

            isHighlightsEnabled: function(){
                var deferred = $q.defer();
                CmsConfigSvc.getProperty('enable_sections').then(function(sections) {
                    const highlightsEnabled = (sections && sections.indexOf('HIGHLIGHTS') !== -1) || false;
                    deferred.resolve(highlightsEnabled);
                }).catch(function(){
                    deferred.resolve(false);
                });
                return deferred.promise;
            }

        };

        /**
         * For 2K resolution and retina then we are downloading special images
         * @returns {string}
         */
        function deviceSize() {
            if (window.matchMedia &&
                window.matchMedia('(min-width: 2048px)').matches &&
                ItxScreenSizeSvc.isRetina) {
                return 'highRes';
            } else if (ItxScreenSizeSvc.is('xs')) {
                return 'xs';
            } else if (ItxScreenSizeSvc.is('sm')) {
                return 'sm';
            } else if (ItxScreenSizeSvc.is('md')) {
                return 'md';
            } else if (ItxScreenSizeSvc.is('lg')) {
                return 'lg';
            }
        }
        
        function extendedDeviceSize() {
            if (window.matchMedia &&
                window.matchMedia('(min-width: 2048px)').matches &&
                ItxScreenSizeSvc.isRetina) {
                return 'highRes';
            } else if (ItxScreenSizeSvc.isExtended('xs')) {
                return 'xs';
            } else if (ItxScreenSizeSvc.isExtended('sm')) {
                return 'sm';
            } else if (ItxScreenSizeSvc.isExtended('md1')) {
                return 'md';
            } else if (ItxScreenSizeSvc.isExtended('md2')) {
                return 'md2';
            } else if (ItxScreenSizeSvc.isExtended('lg')) {
                 if(ItxCategoryLayoutSvc.isExpanded()) {
                    return 'md3';
                } else {
                    return 'lg';
                }
              
            } else if (ItxScreenSizeSvc.isExtended('lg2')) {
                if(ItxCategoryLayoutSvc.isExpanded()) {
                    return 'md3';
                } else {
                    return 'lg2';
                }
                
            }
        }

        function isInternetExplorer() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf('MSIE ');

            if (msie > 0) {
                // IE 10 or older
                return true;
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11
                return true;
            }

            return false;
        }

    }

})();
//jshint ignore:end